import React from "react";
import { Nav } from "react-bootstrap";
import { NavLink } from "react-router-dom";

import { FaHome, FaQrcode, FaHistory, FaUserAlt } from "react-icons/fa";

const PageFooter = () => {
  return (
    <div className="page-footer border-top shadow-sm ">
      <div className="page-container  container text-center py-0">
        <Nav className="align-items-center justify-content-between bg-white">
          <Nav.Item>
            <NavLink
              to="/"
              className="nav-link"
              activeClassName="active"
              isActive={(match) => {
                if (match?.url === "/") {
                  return true;
                }
              }}
            >
              <div className="d-flex flex-column align-items-center justify-content-center fs-7">
                <FaHome size={20} />
                <div className="fs-7">Beranda</div>
              </div>
            </NavLink>
          </Nav.Item>
          <Nav.Item>
            <NavLink to="/scan" className="nav-link" activeClassName="active">
              <div className="d-flex flex-column align-items-center justify-content-center fs-7">
                <FaQrcode size={20} />
                <div className="fs-7">Scan</div>
              </div>
            </NavLink>
          </Nav.Item>
          <Nav.Item>
            <NavLink
              to="/riwayat"
              className="nav-link"
              activeClassName="active"
            >
              <div className="d-flex flex-column align-items-center justify-content-center fs-7">
                <FaHistory size={20} />
                <div className="fs-7">Riwayat</div>
              </div>
            </NavLink>
          </Nav.Item>
          <Nav.Item>
            <NavLink to="/profil" className="nav-link" activeClassName="active">
              <div className="d-flex flex-column align-items-center justify-content-center fs-7">
                <FaUserAlt size={20} />
                <div className="fs-7">Profil</div>
              </div>
            </NavLink>
          </Nav.Item>
        </Nav>
      </div>
    </div>
  );
};

export default PageFooter;
